<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Услуги, предоставляемые в палате, и меры предосторожности</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Что приготовить</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Руководство по обходу палат</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Руководство по питанию</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Руководство по посещению и меры предосторожности</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Прочее</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Услуги, предоставляемые в палате, и меры предосторожности</h3>
            <h4 class="bullet02 type2 num1 depth">Как позвонить в случае чрезвычайной ситуации</h4>
            <p class="depth">
                В случае чрезвычайной ситуации или, когда вам нужна помощь медсестры, нажмите на звонок экстренной помощи, прикрепленный к кровати или стене в ванной или душевой, чтобы получить немедленную помощь.
            </p>

            <h4 class="bullet02 type2 num2 depth">Надевание браслета</h4>
            <p class="depth">
                Чтобы точно идентифицировать пациента, вы должны носить идентификационный браслет пациента, который используется для подтверждения имени и регистрационного номера пациента. Если браслет загрязнен или поврежден, пожалуйста, сообщите об этом в сестринский пункт. Мы немедленно заменим его.
            </p>

            <h4 class="bullet02 type2 num3 depth">Предотвращение пропажи или похищения педиатрических пациентов</h4>
            <p class="depth">
                Чтобы предотвратить пропажу или похищение педиатрических пациентов, опекунов просят всегда находиться рядом с ними.
            </p>

            <h4 class="bullet02 type2 num4 depth">
                Если вы заметили какие-либо необычные симптомы (изменения сознания, боль в груди, кровотечение, судороги), пожалуйста, немедленно сообщите об этом медицинскому персоналу или сотрудникам больницы.
            </h4>

            <h4 class="bullet02 type2 num5 depth">Перевод в палату</h4>
            <p class="depth">
                Перемещение на другую койку на том же этаже палаты запрещено по таким причинам, как безопасность пациента (прием лекарств, забор крови, распределение, лечение).
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Что приготовить</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">Личные предметы для подготовки</h4>
                    <p class="bullet03 depth font-main">Идентификационная карта пациента (обязательно)</p>
                    <p class="bullet05 depth">Для подтверждения личности — мобильное удостоверение личности или страховой полис</p>
                    <p class="bullet05 depth">Если пациент несовершеннолетний, можно использовать свидетельство о родстве или выписку из реестра</p>
                    <p class="bullet05 depth font-sub">Закон о национальном медицинском страховании «Обязательная система подтверждения личности пациента» вступает в силу с 20 мая 2024 года</p>
                    <p class="bullet03 depth">Лекарства: Предоставьте рецепт на текущие лекарства или пакет с названием лекарства в медсестринскую станцию отделения</p>
                    <p class="bullet03 depth">Предметы: Средства личной гигиены, полотенца, закрытые тапочки для пациентов (тапочки и кроксы запрещены), туалетная бумага, стакан для воды, постельное белье для сопровождающего и другие личные вещи</p>
                    <h4 class="bullet02 type2 num2 depth">Дополнительные замечания</h4>
                    <p class="bullet03 depth">Если планируется операция, обязательно удалите маникюр</p>
                    <p class="bullet03 depth">Предметы: Средства личной гигиены, полотенца, закрытые тапочки для пациентов (тапочки и кроксы запрещены), туалетная бумага. Для предотвращения инфекций, пожаров и несчастных случаев запрещено использование увлажнителей воздуха, электрочайников, электрических одеял, вентиляторов и других электроприборов, а также воспламеняющихся и нагреваемых материалов. Постельное белье для сопровождающего и другие личные вещи</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Руководство по обходу палат</h3>
            <p class="depth">Обходы проводятся в 7.20-09.00 и могут варьироваться в зависимости от условий отделения.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Руководство по питанию</h3>
            <p class="bullet04 num1 depth">
                Завтрак подается в 7.00-8.00, обед в 12.00-13.00 и ужин в 18.00-19.00. Пожалуйста, воздержитесь от принесения еды с собой или приема пищи в ресторанном дворике в целях лечения пациентов и профилактики инфекций.
            </p>
            <p class="bullet04 num2 depth">
                Хранение продуктов в холодильнике: приготовленные продукты, за исключением ферментированных, следует хранить не более 24 часов, так как при длительном хранении существует риск порчи.
            </p>
            <p class="bullet04 num3 depth">
                По желанию пациента он может выбрать «специальное питание», которое не покрывается страховым полисом, и в этом случае пациент оплачивает полную стоимость.
            </p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Руководство по посещению и меры предосторожности</h3>
            <p class="bullet04 num1 depth">
                Для быстрого выздоровления, стабилизации состояния пациента и профилактики инфекций детям в возрасте до 13 лет со слабой иммунной системой запрещается посещать инфекционное отделение и отделение интенсивной терапии.
            </p>
            <p class="bullet04 num2 depth">
                Посещения опекунов с простудными или инфекционными заболеваниями ограничены, и, если вы хотите защитить свою частную жизнь или не желаете посещать, пожалуйста, сообщите об этом в отделение сестринского ухода.
            </p>
            <p class="bullet04 num3 depth">Пожалуйста, помогите составить список посетителей.</p>
            <p class="bullet04 num4 depth"><span class="font-main">Время посещения</span></p>
            <p class="bullet05 depth">Будни с 18.00 до 20.00</p>
            <p class="bullet05 depth">Выходные и праздничные дни 10.00-12.00, 18.00-20.00</p>
            <p class="bullet05 depth">Время посещения ограничено 2 часами, и, пожалуйста, воздержитесь от посещения после 20.00 ч.</p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">Прочее</h3>
            <h4 class="bullet02 type2 num1 depth">Удобства</h4>
            <p class="depth">Палата: в ней есть общественные туалеты, комнаты для сбора отходов, душевая, комната отдыха, торговые автоматы, кулер, микроволновая печь, многоцелевая комната и т. д.</p>
            <p class="depth">Имеются автоматическое платежное устройство медицинских расходов, регистратор компакт-дисков с радиологическими файлами, круглосуточный магазин, банк, кафе, фуд-корт, пекарня, магазин медицинских приборов, автоматический ящик для посылок, и т. д.</p>

            <h4 class="bullet02 type2 num2 depth">Раздельный сбор отходов</h4>
            <p class="depth">Пожалуйста, отделите и выбросьте использованные спиртовые тампоны и марлю в контейнеры для медицинских отходов.</p>

            <h4 class="bullet02 type2 num3 depth">Запрет курения</h4>
            <p class="depth">В целях охраны здоровья пациентов и предотвращения пожаров вся госпиталь является зоной для некурящих, поэтому, пожалуйста, примите меры по прекращению курения.</p>

            <h4 class="bullet02 type2 num4 depth">Меры по предотвращению пожаров и ликвидации их последствий</h4>
            <p class="depth">
                Пожалуйста, воздержитесь от использования переносных газовых плит, электрических вентиляторов, электрообогревателей и проноса легковоспламеняющихся материалов в палату. В случае пожара незамедлительно сообщите об этом медсестре и эвакуируйтесь через эвакуационную комнату и аварийную лестницу в соответствии с указаниями персонала госпиталя.
            </p>

            <h4 class="bullet02 type2 num5 depth">Руководство по прогулке</h4>
            <p class="depth">
                Прогулки за пределами здания запрещены в принципе. Однако, с разрешения дежурной медсестры и в сопровождении опекуна, вы можете прогуляться по саду на 4-м этаже здания и по лужайке у северных ворот. Пожалуйста, берите с собой на прогулку мобильный телефон и возвращайтесь в свою комнату к 18.00.
            </p>

            <h4 class="bullet02 type2 num6 depth">Рассмотрение жалоб и недовольства</h4>
            <p class="depth">
                Если у вас возникнут какие-либо вопросы, неудобства или пожелания во время пребывания в больнице, вы можете посетить офис по работе с клиентами на 1-м этаже, позвонить, воспользоваться веб-сайтом госпиталя или ящиком для обратной связи с клиентами.     
            </p>

            <h4 class="bullet02 type2 num7 depth">Плата за парковку</h4>
            <p class="depth">Пожалуйста, ознакомьтесь с информацией о плате за парковку, размещенной на доске объявлений палаты.</p>

            <h4 class="bullet02 type2 num8 depth">Остерегайтесь потери или кражи</h4>
            <p class="depth">
                <span class="font-main">
                    Не храните ценные вещи и наличные деньги в палате, 
                </span>
                снимайте все вспомогательные приспособления, такие как зубные протезы, слуховые аппараты, очки и линзы, во время обследований, процедур и операций и,
                <span class="font-main">
                    пожалуйста, храните их внимательно. Госпиталь не несет ответственности за убытки, вызванные вашей собственной небрежностью. 
                </span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">Управление имуществом</span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>Пожалуйста, будьте осторожны, чтобы не потерять вещи, когда будете забирать их для обследования или лечения.</p>
                <p>Госпиталь не несет ответственности за потерю, вызванную вашей собственной небрежностью.</p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">Информация о религиозных объектах</h4>
            <p class="depth">
                Эта госпиталь является христианской больницей, и воскресные службы проводятся в 10.00 по воскресеньям, службы по средам – в 17.00, а детские/молодежные службы проводятся в 10.00 по четвергам в церкви Банджу на 3-м этаже здания С. Для получения дополнительной информации о посещении приходов, получения консультаций по вопросам веры и другим религиозным вопросам, пожалуйста, звоните в кабинет пастырских консультаций (02-6986-5724). Кабинет пастырских консультаций и молитвенная комната расположены на 3-м этаже корпуса С.
            </p>

            <h4 class="bullet02 type2 num10 depth">Выдача различных справок</h4>
            <p class="depth">
                Пожалуйста, заранее сообщите лечащему врачу или медсестре обо всех необходимых документах, таких как сертификат о диагнозе, медицинские записи и видеозаписи и т. д.
            </p>

            <h4 class="bullet02 type2 num11 depth">
                Мы уважаем и защищаем права и обязанности пациента на протяжении всего процесса лечения.
            </h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Права пациента</th>
                                <th>Обязанности пациента</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Право на получение медицинской помощи</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Обязательство доверять медицинскому персоналу и уважать его</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Право знать и право на самоопределение</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Право на конфиденциальность</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Обязательство не осуществлять лечение ненадлежащим образом</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Право обращаться за консультацией и посредничеством</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Право на получение медицинских услуг в безопасных медицинских условиях</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">Руководство по отказу от лечения</h4>
            <p class="depth">
                Если пациент, опекун и т. д. создают ситуацию, которая может представлять собой оскорбление, диффамацию, физическое нападение или воспрепятствование деятельности соответствующего медицинского работника, тем самым препятствуя выполнению медицинским работником обычных медицинских процедур, в лечении может быть отказано (право на отказ от лечения) в пределах, не нарушающих Закон о медицинской службе или Закон о неотложной медицинской помощи.
            </p>
            <h4 class="bullet02 type2 num13 depth">
                Если пациент или опекун (посетитель) причиняет ущерб сотруднику посредством насилия (словесные оскорбления, угрозы, массовые беспорядки, сексуальное насилие, сексуальные домогательства, порча имущества и т. д.), это может быть наказано в соответствии с соответствующими законами и нормативными актами.
            </h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>